export const COLORS = {
  "ui1": "#373737",
  "ui2": "#5B5B5B",
  "ui3": "#8D8D8D",
  "ui4": "#BABABA",
  "ui5": "#E1E1E1",
  "orange": "#FF6A00",
  "orangeTint": "#FFD8BD",
  "blue": "#00C2FF"
}